<template>
  <div class="chiamate-container">
    <div class="header">
      <h1>{{ $t('chiamate_cameriere') || 'Chiamate Cameriere' }}</h1>
      <button class="btn btn-outline-secondary btn-sm" @click="home">{{ $t('home') }}</button>
    </div>
    
    <div class="calls-grid">
      <transition-group name="list" tag="div" class="grid-inner">
        <div 
          v-for="call in chiamateCameriere" 
          :key="call.sala + call.tavolo" 
          class="call-square"
          @click="confirmEvasion(call)"
        >
          <div class="sala-name">{{ call.sala }}</div>
          <div class="tavolo-num">T{{ normalizeId(call.tavolo) }}</div>
          <div class="tap-hint">{{ $t('evadi') || 'Tocca per evadere' }}</div>
        </div>
      </transition-group>
      
      <div v-if="chiamateCameriere.length === 0" class="no-calls">
        <div class="icon">🔔</div>
        <p>{{ $t('nessuna_chiamata') || 'Nessuna chiamata attiva' }}</p>
      </div>
    </div>

    <!-- Modal Evadi -->
    <div class="modal-overlay" v-if="showEvadiModal">
      <div class="modal-box">
        <h3>{{ $t('evasione_chiamata') || 'Evasione Chiamata' }}</h3>
        <p>Confermi l'evasione per il tavolo <b>T{{ normalizeId(selectedCall.tavolo) }}</b> in <b>{{ selectedCall.sala }}</b>?</p>
        <div class="modal-btns">
          <button class="btn btn-secondary" @click="showEvadiModal = false">{{ $t('annulla') || 'Annulla' }}</button>
          <button class="btn btn-danger" @click="evadiChiamata">{{ $t('evadi') || 'Evadi' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { io } from "socket.io-client";
import { store } from '../store/store.js';

export default {
  name: 'ChiamateCameriere',
  data() {
    return {
      chiamateCameriere: [],
      socket: io(process.env.VUE_APP_SOCKET_URL, { autoConnect: true }),
      store,
      showEvadiModal: false,
      selectedCall: null
    };
  },
  methods: {
    home() {
      this.$router.push({ name: 'Gestionale' });
    },
    normalizeId(id) {
      let tid = String(id);
      return tid.startsWith('t') ? tid.slice(1) : tid;
    },
    loadCalls() {
      const saved = localStorage.getItem('chiamateCameriere');
      if (saved) {
        this.chiamateCameriere = JSON.parse(saved);
      }
    },
    confirmEvasion(call) {
      this.selectedCall = call;
      this.showEvadiModal = true;
    },
    evadiChiamata() {
      if (!this.selectedCall) return;
      
      const { sala, tavolo } = this.selectedCall;
      
      // Rimuovi localmente
      this.chiamateCameriere = this.chiamateCameriere.filter(c => 
        !(c.sala === sala && c.tavolo === tavolo)
      );
      localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
      
      // Invia evento socket
      this.socket.emit('evasioneChiamata', { sala, tavolo });
      
      this.showEvadiModal = false;
      this.selectedCall = null;
    }
  },
  mounted() {
    this.loadCalls();
    
    // Ascolta nuove chiamate
    this.socket.on('ricevutaChiamataCameriere', (messaggio) => {
      console.log("Socket: ricevutaChiamataCameriere", messaggio);
      const esisteGia = this.chiamateCameriere.some(c => 
        c.sala.trim().toLowerCase() === messaggio.sala.trim().toLowerCase() && 
        String(c.tavolo) === String(messaggio.tavolo)
      );

      if (!esisteGia) {
        // Aggiungi a SINISTRA (nuovo)
        this.chiamateCameriere.unshift({
          sala: messaggio.sala,
          tavolo: messaggio.tavolo
        });
        localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
      }
    });

    // Ascolta anche l'evento "cameriere" se inviato direttamente dal payload suggerito dall'utente
    this.socket.on('cameriere', (messaggio) => {
        console.log("Socket: cameriere", messaggio);
        // Se il messaggio ha una struttura diversa, adattalo
        const sala = messaggio.sala || 'N/A';
        const tavolo = messaggio.tavolo || messaggio.label || 'N/A';
        
        const esisteGia = this.chiamateCameriere.some(c => 
            c.sala === sala && c.tavolo === tavolo
        );
        if (!esisteGia) {
            this.chiamateCameriere.unshift({ sala, tavolo });
            localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
        }
    });

    // Ascolta evasioni da altri client
    this.socket.on('ricevutaEvasioneChiamata', (messaggio) => {
      console.log("Socket: ricevutaEvasioneChiamata", messaggio);
      const targetSala = messaggio.sala.trim().toLowerCase();
      const targetTavolo = String(messaggio.tavolo);
      
      this.chiamateCameriere = this.chiamateCameriere.filter(c => {
        const sameSala = c.sala.trim().toLowerCase() === targetSala;
        const sameTavolo = String(c.tavolo) === targetTavolo;
        return !(sameSala && sameTavolo);
      });
      localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
    });
  }
};
</script>

<style scoped>
.chiamate-container {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: 'Inter', -apple-system, sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.header h1 {
  font-weight: 800;
  color: #2d3436;
  margin: 0;
  font-size: 1.8rem;
}

.calls-grid {
  display: flex;
  flex-direction: column;
}

.grid-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

/* Newest on left, oldest on right: we use default flex direction and unshift data */

.call-square {
  width: 160px;
  height: 160px;
  background: linear-gradient(135deg, #ff7675 0%, #d63031 100%);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(214, 48, 49, 0.3);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  animation: pulse 2s infinite;
}

.call-square:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 15px 30px rgba(214, 48, 49, 0.4);
}

.call-square:active {
  transform: scale(0.95);
}

.sala-name {
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.9;
  margin-bottom: 5px;
}

.tavolo-num {
  font-size: 2.8rem;
  font-weight: 900;
  letter-spacing: -1px;
}

.tap-hint {
  font-size: 0.7rem;
  margin-top: 10px;
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 10px;
  border-radius: 10px;
}

.no-calls {
  text-align: center;
  margin-top: 100px;
  color: #b2bec3;
}

.no-calls .icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.5;
}

/* Animations */
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

.list-enter-active, .list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}
.list-leave-to {
  opacity: 0;
  transform: scale(0.5);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-box {
  background: white;
  padding: 30px;
  border-radius: 20px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
}

.modal-box h3 {
  margin-bottom: 15px;
  font-weight: 700;
}

.modal-btns {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 25px;
}
</style>
